import type { FacetOption } from './get-facet-options'

/**
 * Drops dead-end options from a dropdown, keeping the one the document itself is classified
 * with so a historical value stays visible (rendered disabled) instead of silently vanishing.
 *
 * Anchored on the persisted `document.category` rather than the live field value: anchoring on
 * the live value would make the option disappear the moment the reviewer picks something else.
 */
export function getVisibleFacetOptions({
  options,
  anchorLabel,
}: {
  options: FacetOption[]
  anchorLabel: string | undefined
}): FacetOption[] {
  return options.filter((option) => !option.isDeprecated || option.label === anchorLabel)
}
